import React from 'react';
import IconWrapper from '../IconWrapper';
const SpinnerIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 69 70" }),
    React.createElement("g", { transform: "matrix(1 0 0 -1 2 67)", fill: "none", strokeLinecap: "round" },
        React.createElement("circle", { stroke: "#d7d7d7", strokeWidth: "4", cx: "32", cy: "32", r: "32" }),
        React.createElement("path", { d: "M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32z", stroke: "#4E4E4E", strokeWidth: "6", strokeDasharray: "100 2000" }))));
export default SpinnerIcon;
//# sourceMappingURL=SpinnerIcon.js.map